export type CollectionStateKey = 'receipts' | 'products' | 'deals' | 'analytics';

export const EMPTY_STATE_COPY: Record<CollectionStateKey, { title: string; description: string }> =
  {
    receipts: {
      title: 'No receipts yet',
      description: "They'll show up here automatically as your device captures them.",
    },
    products: {
      title: 'No products yet',
      description: 'Products appear here as receipts come in.',
    },
    deals: {
      title: 'No deals running',
      description: 'Create one to promote a product or discount.',
    },
    analytics: {
      title: 'Not enough data yet',
      description: 'Not enough data yet for this period. Check back after a few more receipts.',
    },
  };

export const NETWORK_ERROR_COPY = {
  title: "Couldn't load this.",
  fallbackMessage: 'Check your connection and try again.',
  retryLabel: 'Retry',
  retryingLabel: 'Retrying...',
} as const;
